export const MAIN_COLOR = "#F9C611";
